// ONLY RUN ON DRY SHAMPOO QUIZ PAGE (SAFE CHECK)
const dryPath = window.location.pathname.toLowerCase();
const onDryShampooQuizPage =
  dryPath.includes("dryshampoo-quiz") || dryPath.includes("dry-shampoo-quiz");

if (onDryShampooQuizPage) {
  console.log("Dry Shampoo Quiz JS loaded ✔");

  // MAIN QUIZ SUBMIT FUNCTION
  window.submitDryShampooQuiz = function () {
    console.log("submitDryShampooQuiz triggered");

    // COLLECT ANSWERS
    const oily = document.querySelector("input[name='oily']:checked")?.value;
    const feel = document.querySelector("input[name='feel']:checked")?.value;
    const goal = document.querySelector("input[name='goal']:checked")?.value;
    const wash = document.querySelector("input[name='wash']:checked")?.value;

    if (!oily || !feel || !goal || !wash) {
      alert("Please answer all questions before submitting!");
      return;
    }

    // SCORING SYSTEM
    let scoreClean = 0;
    let scoreTexture = 0;

    // OILINESS
    if (oily === "oilyFast") scoreClean++;
    if (oily === "dry") scoreTexture++;

    // FEEL
    if (feel === "clean") scoreClean++;
    if (feel === "texture") scoreTexture++;

    // GOAL
    if (goal === "freshClean") scoreClean++;
    if (goal === "volume" || goal === "texture") scoreTexture++;

    // WASH FREQUENCY
    if (wash === "daily") scoreClean++;
    if (wash === "2-3" || wash === "4plus") scoreTexture++;

    // FINAL RESULT (TIES → CLEANER)
    let result = scoreClean >= scoreTexture ? "cleaner" : "texture";
    console.log("Final dry shampoo result:", result);

    displayDryResult(result);
  };

  // PRODUCT DATA
  const dryProducts = {
    cleaner: {
      name: "Cleaner-than-Clean Dry Shampoo",
      img: "https://www.bella-hue.com/cdn/shop/files/Organic_Powder_Base_Dry_Shampoo_With_Brush.png?v=1755814811&width=800",
      url: "https://www.bella-hue.com/products/dry-shampoo",
      desc:
        "A weightless, no-grit dry shampoo that absorbs oil invisibly and keeps roots light, fresh, and airy."
    },
    texture: {
      name: "Texture + Volume Dry Shampoo",
      img: "https://www.bella-hue.com/cdn/shop/files/Dry_shampoo_powder_extra_volume_9f3ea000-33de-4bff-8561-15ed321832dc.png?v=1740000096&width=800",
      url: "https://www.bella-hue.com/products/texture-volume-powder-aerosol-free-pump",
      desc:
        "Adds grip, fuller roots, and buildable volume — perfect for styling or hair that falls flat."
    }
  };

  // DISPLAY RESULT BOX
  function displayDryResult(key) {
    const product = dryProducts[key];
    const box = document.getElementById("dryShampooResult");

    if (!box) {
      console.error("Result box #dryShampooResult not found.");
      return;
    }

    box.innerHTML = `
      <div style="text-align:center;">
        <img src="${product.img}" 
             alt="${product.name}" 
             style="width:100%; max-width:600px; border-radius:12px; margin-bottom:20px;">
        <h2>${product.name}</h2>
        <p>${product.desc}</p>
        <a href="${product.url}" class="button" style="margin-top:15px;">Shop Now</a>
      </div>
    `;

    box.style.display = "block";

    const restartBtn = document.getElementById("restartQuizBtn");
    if (restartBtn) restartBtn.style.display = "block";

    // ⭐ AUTO SCROLL TO RESULT ⭐
    setTimeout(() => {
      box.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  }

  // IMPACT-SAFE CLICK LISTENER (MATCHES YOUR HTML)
  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "quizSubmitBtn") {
      e.preventDefault();
      console.log("quizSubmitBtn clicked ✔");
      submitDryShampooQuiz();
    }
  });

  // EXTRA SAFETY: CATCH FORM SUBMIT
  document.addEventListener("submit", function (e) {
    if (e.target && e.target.id === "dryShampooQuizForm") {
      e.preventDefault();
      submitDryShampooQuiz();
    }
  });

} // END PAGE CHECK